// start:ng42.barrel
import './mass-adjustment-student-detail.component';
import './mass-adjustment-student-filter.component';
import './mass-adjustment-student.component';
// end:ng42.barrel

